<template>
  <div class="">
    <Breadcrumb :title="$t('miga.Confirmation')" />
    <HeadingBox
      :title="$t('confirmation.title')"
      :description="$t('confirmation.description')"
    />

    <div class="row mb-5">
      <div class="col-12 col-lg-7">
        <Ticket :ticket="ticket" :tenant="tenant" />
      </div>

      <div class="col-12 col-lg-5">
        <div class="mx-5 my-3">
          <br />
          <div class="heading-text heading-line text-center mt-5">
            <h1>
              <i class="far fa-calendar fa-2x"></i>
            </h1>
            <br />
            <p v-html="$t('confirmation.yatienes')" />
            <router-link
              :to="{ name: 'MyTickets' }"
              class="btn text-center btn-upvehu-blanco mt-5"
            >
              {{ $t("vermiscitas") }} <span class="mx-3 py-4"> </span>
              <i class="fa fa-chevron-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import HeadingBox from "../components/HeadingBox";
import APIPortal from "@/services/APIPortal.js";
import Ticket from "../components/Ticket";

import Session from "@/session/Session.js";

export default {
  name: "Confirmation",
  components: { Ticket, HeadingBox, Breadcrumb },
  props: {},
  computed: {},
  data: () => ({
    Session,
    ticket: Session.getTicket(),
    tenant: Session.getTenant(),
  }),
  async mounted() {
    await APIPortal.getTeleconfURL()
  },
  unmounted() {
    window.console.log('unmounting ..')
    Session.setTicket(null)
    Session.setServicePoint(null)
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>

